import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { getNewsByFilter } from "../../api/apiHandler";
import { getMediaBaseUrl } from "../../utils/backendUrl";

// We can export this mock data to be used by the BlogDetail page as well
export const mockBlogs = [
  {
    id: 1,
    title: "ग्रामीण भारत में डिजिटल पत्रकारिता का उदय",
    excerpt: "स्मार्टफोन और स्थानीय समाचार पोर्टल किस प्रकार ग्रामीण क्षेत्रों तक सूचना पहुँचाने का तरीका बदल रहे हैं।",
    content: "डिजिटल पत्रकारिता ने ग्रामीण भारत में तहलका मचा दिया है। सस्ते डेटा और स्मार्टफोन की व्यापक उपलब्धता के कारण, समाचार अब सुबह के अखबार तक सीमित नहीं रह गए हैं। स्थानीय रिपोर्टर अब दूरदराज के गांवों से घटनाओं का सीधा प्रसारण कर पा रहे हैं, जिससे स्थानीय प्रशासन और सामाजिक मुद्दों में अभूतपूर्व पारदर्शिता आ रही है। यह बदलाव नागरिकों को वास्तविक समय में अपने नेताओं को जवाबदेह ठहराने के लिए सशक्त बना रहा है।",
    author: "एडमिन",
    date: "6 अगस्त 2026",
    readTime: "5 मिनट पढ़ें",
    image: "https://images.unsplash.com/photo-1585829365295-ab7cd400c167?auto=format&fit=crop&q=80&w=1200&h=600"
  },
  {
    id: 2,
    title: "नई शिक्षा नीति 2026 को समझना",
    excerpt: "संशोधित पाठ्यक्रम का छात्रों और शिक्षकों पर क्या प्रभाव पड़ेगा, इसका विस्तृत विवरण।",
    content: "2026 की शिक्षा नीति स्कूली ढांचे में आमूलचूल परिवर्तन लाती है, जो रटने की बजाय कौशल-आधारित शिक्षा की ओर बढ़ती है। ग्रामीण क्षेत्रों के स्कूलों को डिजिटल कक्षाएं बनाने के लिए विशेष धन प्राप्त होगा, जिससे शहरी और ग्रामीण शिक्षा मानकों के बीच की खाई कम होगी।",
    author: "एडमिन",
    date: "5 अगस्त 2026",
    readTime: "4 मिनट पढ़ें",
    image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&q=80&w=600&h=400"
  },
  {
    id: 3,
    title: "सतत कृषि: मध्य प्रदेश के लिए आगे का रास्ता",
    excerpt: "मध्य प्रदेश में किसान पर्यावरण की रक्षा करते हुए उपज बढ़ाने के लिए जैविक तरीके अपना रहे हैं।",
    content: "बदलते जलवायु पैटर्न के साथ, खेती के पारंपरिक तरीके अप्रचलित होते जा रहे हैं। पूरे मध्य प्रदेश के किसान जैविक उर्वरकों और जल-संरक्षण तकनीकों की ओर रुख कर रहे हैं। इससे न केवल ऊपरी मिट्टी की रक्षा होती है, बल्कि उपज का बाजार मूल्य भी बढ़ता है।",
    author: "एडमिन",
    date: "4 अगस्त 2026",
    readTime: "6 मिनट पढ़ें",
    image: "https://images.unsplash.com/photo-1500937386664-56d1dfef447b?auto=format&fit=crop&q=80&w=600&h=400"
  },
  {
    id: 4,
    title: "बुंदेलखंड का सांस्कृतिक पुनर्जागरण",
    excerpt: "ऐतिहासिक क्षेत्र में पारंपरिक कला, लोक संगीत और स्थानीय साहित्य के पुनरुद्धार की खोज।",
    content: "बुंदेलखंड की एक समृद्ध सांस्कृतिक विरासत है जो धीरे-धीरे लुप्त हो रही थी। नई स्थानीय पहलों के लिए धन्यवाद, लोक कलाकारों को डिजिटल स्ट्रीम के माध्यम से विश्व स्तर पर प्रदर्शन करने के लिए मंच प्रदान किए जा रहे हैं। साहित्य में स्थानीय बोलियों का पुनरुद्धार भी युवाओं के बीच भारी उछाल देख रहा है।",
    author: "एडमिन",
    date: "3 अगस्त 2026",
    readTime: "7 मिनट पढ़ें",
    image: "https://images.unsplash.com/photo-1600093463592-8e36ae95ef56?auto=format&fit=crop&q=80&w=600&h=400"
  },
  {
    id: 5,
    title: "स्थानीय चुनाव: प्रमुख युद्धक्षेत्र जिन पर नजर रहेगी",
    excerpt: "आगामी नगरपालिका चुनावों और प्रमुख उम्मीदवारों का गहन राजनीतिक विश्लेषण।",
    content: "आगामी नगरपालिका चुनाव एक कड़ी टक्कर साबित होने वाले हैं। सड़क बुनियादी ढांचे और पानी की आपूर्ति जैसे प्रमुख मुद्दे अभियानों पर हावी हैं। हम शीर्ष पांच निर्वाचन क्षेत्रों का विश्लेषण करते हैं जो सत्ता का संतुलन तय करेंगे।",
    author: "एडमिन",
    date: "2 अगस्त 2026",
    readTime: "8 मिनट पढ़ें",
    image: "https://images.unsplash.com/photo-1540910419892-4a36d2c3266c?auto=format&fit=crop&q=80&w=600&h=400"
  }
];

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const BASE_URL = getMediaBaseUrl();

  useEffect(() => {
    let isMounted = true;
    getNewsByFilter({ limit: 12 })
      .then((res) => {
        if (!isMounted) return;
        const items = Array.isArray(res?.data) ? res.data : [];
        const mapped = items.map((item) => ({
          id: item.id || item._id,
          title: item.news_title || item.title || "",
          excerpt: (item.description || item.fullNews || "")
            .replace(/<[^>]*>/g, "")
            .replace(/\s+/g, " ")
            .trim()
            .slice(0, 200),
          content: item.description || item.fullNews || "",
          author: item.reporter_name || "न्यूज़ डेस्क",
          date: item.createdAt ? new Date(item.createdAt).toLocaleDateString("hi-IN") : "",
          readTime: "2 मिनट पढ़ें",
          image: item.thumbnail
            ? item.thumbnail.startsWith("http")
              ? item.thumbnail
              : item.thumbnail.startsWith("/images/")
                ? item.thumbnail
                : `${BASE_URL}/uploads/news/${encodeURIComponent(item.thumbnail)}`
            : "",
        }));
        setBlogs(mapped);
      })
      .catch((err) => console.error("Error fetching latest news:", err))
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="bg-[#f8f9fa] min-h-screen pb-20">
      <Helmet>
        <title>ब्लॉग्स | मंदाकिनी टाइम्स</title>
        <meta name="description" content="मंदाकिनी टाइम्स से विशेषज्ञ राय और ब्लॉग पढ़ें।" />
      </Helmet>

      {/* Hero Header */}
      <div className="bg-brand-purple text-white py-16 px-4 mb-10 relative overflow-hidden">
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-white opacity-5 blur-2xl"></div>
        <div className="max-w-7xl mx-auto relative z-10 text-center">
          <h1 className="text-4xl md:text-5xl font-black tracking-tight mb-4 drop-shadow-md">
            हमारे <span className="text-purple-200">ब्लॉग्स</span>
          </h1>
          <p className="text-red-100 text-lg font-medium max-w-2xl mx-auto">
            हमारे लेखकों की गहरी जानकारी, विशेषज्ञ राय और सम्मोहक कहानियाँ।
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 -mt-8 relative z-20">
        
        {/* Simple Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {(blogs.length > 0 ? blogs : mockBlogs).map((blog) => (
            <Link to={blog.id ? `/news/${blog.id}` : `/blog/${blog.id}`} key={blog.id || blog.title} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 group flex flex-col">
              <div className="h-56 overflow-hidden relative bg-gray-200">
                {/* Image check fallback implemented implicitly via object-cover, but we guarantee src is there */}
                <img 
                  src={blog.image || 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167?auto=format&fit=crop&q=80&w=600&h=400'} 
                  alt={blog.title} 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167?auto=format&fit=crop&q=80&w=600&h=400' }}
                />
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-brand-red transition-colors line-clamp-2 leading-snug">
                  {blog.title}
                </h3>
                <p className="text-gray-600 text-sm mb-6 line-clamp-3 leading-relaxed">
                  {blog.excerpt}
                </p>
                
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center text-xs font-bold text-gray-600">
                      {blog.author.charAt(0)}
                    </div>
                    <div>
                      <p className="text-xs font-bold text-gray-900">{blog.author}</p>
                      <p className="text-[10px] text-gray-500">{blog.date}</p>
                    </div>
                  </div>
                  <span className="text-[11px] font-medium text-gray-400">
                    {blog.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {(loading && blogs.length === 0) ? (
          <div className="text-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-600 border-t-transparent mx-auto"></div>
          </div>
        ) : (blogs.length === 0 && mockBlogs.length === 0) && (
          <div className="text-center py-20">
            <h3 className="text-2xl font-bold text-gray-700">अभी तक कोई ब्लॉग पोस्ट नहीं किया गया है</h3>
          </div>
        )}

      </div>
    </div>
  );
};

export default Blog;
